const CircularProgressBar = (props) => {
  let {
    size = 150,
    progress = 0,
    trackWidth = 10,
    trackColor = `var(--surface-strong)`,
    indicatorWidth = 10,
    indicatorColor = `var(--primary-default)`,
    indicatorCap = `round`,
    label = `Loading...`,
    labelColor = `var(--fg-strong)`,
    spinnerMode = false,
    spinnerSpeed = 1,
  } = props

  const center = size / 2,
    radius = center - (trackWidth > indicatorWidth ? trackWidth : indicatorWidth),
    dashArray = 2 * Math.PI * radius,
    dashOffset = dashArray * ((100 - progress) / 100)

  let hideLabel = size < 100 || !label.length || spinnerMode ? true : false

  return (
    <>
      <div className="svg-pi-wrapper" style={{ width: size, height: size }}>
        <svg className="svg-pi" style={{ width: size, height: size }}>
          <circle
            className="svg-pi-track"
            cx={center}
            cy={center}
            fill="transparent"
            r={radius}
            style={{ stroke: trackColor }}
            strokeWidth={trackWidth}
          />
          <circle
            className={`svg-pi-indicator ${spinnerMode ? `svg-pi-indicator--spinner` : ``}`}
            style={{ animationDuration: `${spinnerSpeed * 1000}`, stroke: indicatorColor }}
            cx={center}
            cy={center}
            fill="transparent"
            r={radius}
            strokeWidth={indicatorWidth}
            strokeDasharray={dashArray}
            strokeDashoffset={dashOffset}
            strokeLinecap={indicatorCap}
          />
        </svg>

        {!hideLabel && (
          <div className="svg-pi-label" style={{ color: labelColor }}>
            {!spinnerMode && <span className="svg-pi-label__progress">{`${progress > 100 ? 100 : progress}%`}</span>}
          </div>
        )}
      </div>
    </>
  )
}

export default CircularProgressBar
